$(function () {
  $(document).on('click', '.btn-turma', function (e) {
    e.preventDefault;
    var titulo = $(this).data('turma-titulo');
    var idTurma = $(this).data('turma-id');
    var local = $(this).data('turma-local');
    $('#titulo_turma').val(titulo + ' - ' + local);
    $('#id_turma').val(idTurma);
    openModal('modal-orcamento');
  });
});
